import { IUpdateItemControleUseCase } from "../../../presentation/useCases/update/update_item_controle_multi_use_case";
import { ItemControleEstoque } from "../../models/item_controle_estoque_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class UpdateItemControleUseCase implements IUpdateItemControleUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async updateItemControle(ItemControle: ItemControleEstoque[]): Promise<void> {
    
    await this.repository.updateItemControle(ItemControle)
  }
}
